import { useEffect } from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { ACTION_CODE, EVENT_CODE } from '@constants'
import { ActionRow, Row } from '@types'

import { EVENT_NAME, subscribe, unsubscribe } from '../../../events'

export const useSetFormValueOnVariableChange = (
  formActions: ActionRow[] | undefined,
  setValue: UseFormSetValue<Row>,
  isViewType: boolean
) => {
  useEffect(() => {
    if (isViewType) return

    const setFieldActions = formActions?.filter(
      action =>
        action.actionCode === ACTION_CODE.SET_FIELD_VALUE &&
        action.eventCode === EVENT_CODE.ON_VARIABLE_CHANGE
    )

    if (!setFieldActions || setFieldActions.length === 0) {
      return
    }

    const handleVariableChange = (event: CustomEvent) => {
      const eventDetail = event.detail
      if (!eventDetail?.id) return

      setFieldActions.forEach(action => {
        if (action.variable?.id !== eventDetail.id) return

        const variableValue = eventDetail.value
        const jsValue = action.jsValue

        const processedValue = jsValue
          ? new Function('srcObj', jsValue)({ variableValue }) ?? ''
          : variableValue ?? ''

        setValue(action.objectFieldCode, processedValue, {
          shouldValidate: true,
          shouldDirty: !!processedValue,
        })
      })
    }

    subscribe(EVENT_NAME.CHANGE_VARIABLE_VALUE, handleVariableChange)

    return () => {
      unsubscribe(EVENT_NAME.CHANGE_VARIABLE_VALUE, handleVariableChange)
    }
  }, [isViewType, formActions, setValue])
}
